import { render, staticRenderFns } from "./TalkMsgAlbum.vue?vue&type=template&id=56c17903&scoped=true"
import script from "./TalkMsgAlbum.vue?vue&type=script&lang=js"
export * from "./TalkMsgAlbum.vue?vue&type=script&lang=js"
import style0 from "./TalkMsgAlbum.vue?vue&type=style&index=0&id=56c17903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c17903",
  null
  
)

export default component.exports